import { useState } from "react";

const HIDED_COLUMNS_KEY = "hidedColumnsKey";
const HIDED_SUB_COLUMNS_KEY = "hidedSubColumnsKey";

export function useHidedColumns() {
  const [hidedColumns, setHidedColumns] = useState<string[]>(() => {
    const localStorageHidedColumns = localStorage.getItem(HIDED_COLUMNS_KEY);

    if (!localStorageHidedColumns) return [];

    const data = JSON.parse(localStorageHidedColumns);

    return data;
  });

  const [hidedSubColumns, setHidedSubColumns] = useState<string[]>(() => {
    const localStorageHidedColumns = localStorage.getItem(
      HIDED_SUB_COLUMNS_KEY
    );

    if (!localStorageHidedColumns) return [];

    const data = JSON.parse(localStorageHidedColumns);

    return data;
  });

  const onHideEnviromentCollumn = (label: string) => {
    setHidedColumns((prev) => {
      const updatedHidedColumns = [...prev, label];
      localStorage.setItem(
        HIDED_COLUMNS_KEY,
        JSON.stringify(updatedHidedColumns)
      );
      return updatedHidedColumns;
    });
  };

  const onHideSubCollumn = (label: string) => {
    setHidedSubColumns((prev) => {
      const updatedSubHidedColumns = [...prev, label];
      localStorage.setItem(
        HIDED_SUB_COLUMNS_KEY,
        JSON.stringify(updatedSubHidedColumns)
      );
      return updatedSubHidedColumns;
    });
  };

  const onUpdateHidedColumns = (data: string[]) => {
    setHidedColumns(data);
    localStorage.setItem(HIDED_COLUMNS_KEY, JSON.stringify(data));
  };

  const onUpdateSubHidedColumns = (data: string[]) => {
    setHidedSubColumns(data);
    localStorage.setItem(HIDED_SUB_COLUMNS_KEY, JSON.stringify(data));
  };

  const isColumnHided = (type: string | null) => {
    if (!type) return false;

    return hidedColumns.includes(type);
  };

  const isSubColumnHided = (type: string | null) => {
    if (!type) return false;

    return hidedSubColumns.includes(type);
  };

  return {
    hidedColumns,
    hidedSubColumns,
    onUpdateSubHidedColumns,
    onHideEnviromentCollumn,
    onHideSubCollumn,
    onUpdateHidedColumns,
    isColumnHided,
    isSubColumnHided,
  };
}
